<script lang="ts">
import { PhxsgButton } from '../../Atoms/Button';
import { PhxsgText } from '../../Atoms/Text';

import type { AnchorHTMLAttributes } from 'vue';

export type PhxsgCardJustify = 'start' | 'center';

export interface PhxsgCardProps {
  title?: string;
  text?: string;
  href?: string;
  justify?: PhxsgCardJustify;
  fill?: boolean;
  actionAttrs?: AnchorHTMLAttributes;
}
</script>

<script setup lang="ts">
defineEmits(['click']);

const { justify = 'start', title, text, href, fill = false } = defineProps<PhxsgCardProps>();
</script>

<template>
  <article
    :class="['phxsg-card', { 'phxsg-card--fill': fill }, { 'phxsg-card--justify-center': justify === 'center' }]"
  >
    <figure v-if="$slots.media" class="phxsg-card__media">
      <slot name="media" />
    </figure>

    <div class="phxsg-card__body">
      <PhxsgText
        v-if="title"
        use="h3"
        variant="label"
        size="medium"
        uppercase
        class="phxsg-card__title"
        :align="justify"
      >
        <PhxsgButton v-if="href" use="a" :href="href" bare expand-target>
          {{ title }}
        </PhxsgButton>
        <template v-else>{{ title }}</template>
      </PhxsgText>

      <slot name="content">
        <PhxsgText v-if="text" color="subtle" :line-clamp="2">{{ text }}</PhxsgText>
      </slot>

      <div v-if="$slots.actions" class="phxsg-card__actions">
        <slot name="actions" />
      </div>
    </div>
  </article>
</template>

<style src="./card.css" />
